import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PageComponent} from 'features/core/shared/mvs-page/page.component';
import {MvsCoreService} from 'features/core/shared/service/mvs-core.service';
import {PageHeaderConfig} from 'features/core/shared/service/page/page-header-config.interface';
import {
    MvsConfigHeaderComponent
} from 'features/core/shared/components/mvs-config-header/mvs-config-header.component';

/**
* Abgleich (reconciliation) page (P3) for Sachbearbeitung / Controlling.
*
* Drives the received-statement-vs-expectation reconciliation: runs
* POST /cn/reconciliation/run and POST /cn/reconciliation/abgleich, and renders the
* resulting CommissionReconciliation rows (status OK/UNDER/OVER/MISSING/UNEXPECTED/MANUAL/BONUS)
* with their delta and components.
*
* Header runs in Component-Mode via MvsConfigHeaderComponent ('Abgleich'), with cross-links
* to the Provisions-Dashboard and the cn config page so all three cn screens stay reachable.
*
* NOTE (architecture shell): the run/abgleich input panel, the CnReconciliationApiService
* call/polling and the result table (CnReconciliationResultDto / CnAbgleichResultDto) are
* wired by the Data / Component specialist next. This file establishes the routed page
* skeleton, the inheritance contract and the header only.
*/
@Component({
    selector: 'mvs-cn-reconciliation-page',
    templateUrl: './cn-reconciliation.page.html',
    styleUrls: ['./cn-reconciliation.page.scss'],
    standalone: false
})
export class CnReconciliationPage extends PageComponent implements OnInit {

    defaultLabel: string = 'Abgleich';

    constructor(
        protected override route: ActivatedRoute,
        protected override coreService: MvsCoreService
    ) {
        super(route, coreService);
    }

    ngOnInit(): void {
        this.defaultLabel = 'Abgleich';
        super.ngOnInit();
        this.initialized = true;
    }

    getPageHeaderConfig(): PageHeaderConfig {
        return {
            component: MvsConfigHeaderComponent,
            inputs: {
                header: 'Abgleich',
                categoryTypeMode: 'configuration',
                icon: 'fa-light fa-scale-balanced',
                links: [
                    {label: 'Eingangsfreigabe', icon: 'fa-light fa-clipboard-check', url: 'cn/import-review'},
                    {label: 'Modell-Vergleich', icon: 'fa-light fa-scale-balanced', url: 'cn/model-comparison?tab=abgleich'},
                    {label: 'Dashboard', icon: 'fa-light fa-gauge', url: 'cn/dashboard'},
                    {label: 'Konfiguration', icon: 'fa-light fa-coins', url: 'cn/config'}
                ]
            }
        };
    }
}
